export default class AccountOpening {
  constructor() {
    this.statusCount = null;
    this.accountOpeningListData = [];
    this.totalCount = 0;
    this.selectedAccount = {};
    this.documents = {ssn: {}, dl: {}, criticalAlerts: {}, dndbw: {}};
    this.equifaxResult = {
      dowJonesResult: [],
      dndbResult: [],
      identityVerificationComments: '',
      criticalAlertsComments: '',
      dndbwComments: '',
    };
    this.criticalAlertsComments = '';
    this.dndbwComments = '';
    this.accountNumbersDropdownList = [];
    this.clientsDropdownList = [];
    this.reasonsDropdownList = [];
  }
}
